import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { caseInsensitiveMap1xhpwzg797p51 as caseInsensitiveMap } from './Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  Entry2xmjmyutzoq3p as Entry,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { unmodifiable2pi9okt3ceep6 as unmodifiable } from './Collections.web.mjs';
import {
  firstOrNull1982767dljvdy as firstOrNull,
  toSet2orjxp16sotqu as toSet,
  plus310ted5e4i90h as plus,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString1n9qg6fb0b5i8 as toString,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals_0,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function appendAll(_this__u8e3s4, builder) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = builder.entries_qbkxv4_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.collections.component1' call
    var name = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var values = element.get_value_j01efc_k$();
    _this__u8e3s4.appendAll_ytnfgb_k$(name, values);
  }
  return _this__u8e3s4;
}
function ensureListForKey($this, name) {
  var tmp0_elvis_lhs = $this.values_1.get_wei43m_k$(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    $this.validateName_mv1fw7_k$(name);
    // Inline function 'kotlin.collections.set' call
    $this.values_1.put_4fpzoq_k$(name, this_0);
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
var StringValuesBuilderImplClass;
function StringValuesBuilderImpl() {
  if (StringValuesBuilderImplClass === VOID) {
    class $ {
      constructor(caseInsensitiveName, size) {
        caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
        size = size === VOID ? 8 : size;
        this.caseInsensitiveName_1 = caseInsensitiveName;
        this.values_1 = this.caseInsensitiveName_1 ? caseInsensitiveMap() : LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(size);
      }
      get_caseInsensitiveName_ehooe5_k$() {
        return this.caseInsensitiveName_1;
      }
      getAll_ffxf4h_k$(name) {
        return this.values_1.get_wei43m_k$(name);
      }
      contains_zh0gsb_k$(name) {
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_0 = this.values_1;
        return (isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).containsKey_aw81wo_k$(name);
      }
      names_1q9mbs_k$() {
        return this.values_1.get_keys_wop4xp_k$();
      }
      isEmpty_y1axqb_k$() {
        return this.values_1.isEmpty_y1axqb_k$();
      }
      entries_qbkxv4_k$() {
        return unmodifiable(this.values_1.get_entries_p20ztl_k$());
      }
      set_j87cuq_k$(name, value) {
        this.validateValue_x1igun_k$(value);
        var list = ensureListForKey(this, name);
        list.clear_j9egeb_k$();
        list.add_utx5q5_k$(value);
      }
      get_6bo4tg_k$(name) {
        var tmp0_safe_receiver = this.getAll_ffxf4h_k$(name);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
      }
      append_rhug0a_k$(name, value) {
        this.validateValue_x1igun_k$(value);
        ensureListForKey(this, name).add_utx5q5_k$(value);
      }
      appendAll_k8dlt1_k$(stringValues) {
        stringValues.forEach_jocloe_k$((name, values) => {
          this.appendAll_ytnfgb_k$(name, values);
          return Unit_instance;
        });
      }
      appendAll_ytnfgb_k$(name, values) {
        // Inline function 'kotlin.let' call
        var list = ensureListForKey(this, name);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = values.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          this.validateValue_x1igun_k$(element);
        }
        addAll(list, values);
      }
      appendMissing_dlfvfk_k$(name, values) {
        var tmp0_safe_receiver = this.values_1.get_wei43m_k$(name);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toSet(tmp0_safe_receiver);
        var existing = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = values.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (!existing.contains_aljjnj_k$(element)) {
            destination.add_utx5q5_k$(element);
          }
        }
        this.appendAll_ytnfgb_k$(name, destination);
      }
      remove_6241ba_k$(name) {
        this.values_1.remove_gppy8k_k$(name);
      }
      clear_j9egeb_k$() {
        this.values_1.clear_j9egeb_k$();
      }
      validateName_mv1fw7_k$(name) {
      }
      validateValue_x1igun_k$(value) {
      }
    }
    initMetadataForClass($, 'StringValuesBuilderImpl', StringValuesBuilderImpl);
    StringValuesBuilderImplClass = $;
  }
  return StringValuesBuilderImplClass;
}
function get(name) {
  var tmp0_safe_receiver = this.getAll_ffxf4h_k$(name);
  return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
}
function forEach(body) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = this.entries_qbkxv4_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.collections.component1' call
    var k = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    body(k, v);
  }
  return Unit_instance;
}
var StringValuesClass;
function StringValues() {
  if (StringValuesClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'StringValues');
    StringValuesClass = $;
  }
  return StringValuesClass;
}
function tableSizeFor($this, size) {
  var n = size - 1 | 0;
  n = n | (n >>> 1 | 0);
  n = n | (n >>> 2 | 0);
  n = n | (n >>> 4 | 0);
  n = n | (n >>> 8 | 0);
  n = n | (n >>> 16 | 0);
  return n < 4 ? 4 : n + 1 | 0;
}
function caseInsensitiveHashCode($this, s) {
  var h = 0;
  var inductionVariable = 0;
  var last = s.length;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = imul(31, h);
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(s, i);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1 = toString(this_0).toLowerCase();
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt(tmp$ret$1, 0);
      h = tmp + Char__toInt_impl_vasixd(this_1) | 0;
    }
     while (inductionVariable < last);
  return h;
}
function listForKey($this, name) {
  if ($this.entryCount_1 === 0)
    return null;
  var hash = computeHash($this, name);
  var idx = $this.hashBuckets_1[hash & ($this.hashBuckets_1.length - 1 | 0)];
  while (idx >= 0) {
    if (equals($this.keyStorage_1[idx], name, $this.caseInsensitiveName_1)) {
      return $this.valueStorage_1[idx];
    }
    idx = $this.hashNext_1[idx];
  }
  return null;
}
function computeHash($this, key) {
  var tmp;
  if ($this.caseInsensitiveName_1) {
    tmp = caseInsensitiveHashCode(Companion_instance, key);
  } else {
    tmp = getStringHashCode(key);
  }
  return tmp;
}
var StringValuesEntryClass;
function StringValuesEntry() {
  if (StringValuesEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.key_1 = key;
        this.value_1 = value;
      }
      get_key_18j28a_k$() {
        return this.key_1;
      }
      get_value_j01efc_k$() {
        return this.value_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (!(other == null) ? isInterface(other, Entry()) : false) {
          tmp_0 = equals_0(other.get_key_18j28a_k$(), this.key_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals_0(other.get_value_j01efc_k$(), this.value_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.key_1) ^ hashCode(this.value_1);
      }
      toString() {
        return this.key_1 + '=' + toString_0(this.value_1);
      }
    }
    initMetadataForClass($, 'StringValuesEntry', VOID, VOID, [Entry()]);
    StringValuesEntryClass = $;
  }
  return StringValuesEntryClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var StringValuesImplClass;
function StringValuesImpl() {
  if (StringValuesImplClass === VOID) {
    class $ {
      constructor(caseInsensitiveName, values) {
        caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
        values = values === VOID ? emptyMap() : values;
        this.caseInsensitiveName_1 = caseInsensitiveName;
        if (values.isEmpty_y1axqb_k$()) {
          this.entryCount_1 = 0;
          var tmp = this;
          // Inline function 'kotlin.emptyArray' call
          tmp.keyStorage_1 = [];
          var tmp_0 = this;
          // Inline function 'kotlin.emptyArray' call
          tmp_0.valueStorage_1 = [];
          this.hashBuckets_1 = new Int32Array(0);
          this.hashNext_1 = new Int32Array(0);
        } else if (!this.caseInsensitiveName_1) {
          this.entryCount_1 = values.get_size_woubt6_k$();
          var tmp_1 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          var size = this.entryCount_1;
          var tmp_2 = Array(size);
          tmp_1.keyStorage_1 = isArray(tmp_2) ? tmp_2 : THROW_CCE();
          var tmp_3 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          var size_0 = this.entryCount_1;
          var tmp_4 = Array(size_0);
          tmp_3.valueStorage_1 = isArray(tmp_4) ? tmp_4 : THROW_CCE();
          var tableSize = tableSizeFor(Companion_instance, this.entryCount_1);
          var tmp_5 = this;
          var tmp_6 = 0;
          var tmp_7 = new Int32Array(tableSize);
          while (tmp_6 < tableSize) {
            tmp_7[tmp_6] = -1;
            tmp_6 = tmp_6 + 1 | 0;
          }
          tmp_5.hashBuckets_1 = tmp_7;
          var tmp_8 = this;
          var tmp_9 = 0;
          var tmp_10 = this.entryCount_1;
          var tmp_11 = new Int32Array(tmp_10);
          while (tmp_9 < tmp_10) {
            tmp_11[tmp_9] = -1;
            tmp_9 = tmp_9 + 1 | 0;
          }
          tmp_8.hashNext_1 = tmp_11;
          var i = 0;
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = values.get_entries_p20ztl_k$().iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
            // Inline function 'kotlin.collections.component1' call
            var key = _destruct__k2r9zo.get_key_18j28a_k$();
            // Inline function 'kotlin.collections.component2' call
            var value = _destruct__k2r9zo.get_value_j01efc_k$();
            this.keyStorage_1[i] = key;
            var tmp_12 = i;
            // Inline function 'kotlin.collections.List' call
            // Inline function 'kotlin.collections.MutableList' call
            var size_1 = value.get_size_woubt6_k$();
            var list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(size_1);
            // Inline function 'kotlin.repeat' call
            var inductionVariable = 0;
            if (inductionVariable < size_1)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp$ret$13 = value.get_c1px32_k$(index);
                list.add_utx5q5_k$(tmp$ret$13);
              }
               while (inductionVariable < size_1);
            this.valueStorage_1[tmp_12] = list;
            var hash = computeHash(this, key);
            var bucket = hash & (tableSize - 1 | 0);
            this.hashNext_1[i] = this.hashBuckets_1[bucket];
            this.hashBuckets_1[bucket] = i;
            i = i + 1 | 0;
          }
        } else {
          var deduped = caseInsensitiveMap();
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = values.get_entries_p20ztl_k$().iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var _destruct__k2r9zo_0 = _iterator__ex2g4s_0.next_20eer_k$();
            // Inline function 'kotlin.collections.component1' call
            var key_0 = _destruct__k2r9zo_0.get_key_18j28a_k$();
            // Inline function 'kotlin.collections.component2' call
            var value_0 = _destruct__k2r9zo_0.get_value_j01efc_k$();
            var existing = deduped.get_wei43m_k$(key_0);
            if (!(existing == null)) {
              // Inline function 'kotlin.collections.set' call
              var value_1 = plus(existing, value_0);
              deduped.put_4fpzoq_k$(key_0, value_1);
            } else {
              // Inline function 'kotlin.collections.set' call
              deduped.put_4fpzoq_k$(key_0, value_0);
            }
          }
          this.entryCount_1 = deduped.get_size_woubt6_k$();
          var tmp_13 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          var size_2 = this.entryCount_1;
          var tmp_14 = Array(size_2);
          tmp_13.keyStorage_1 = isArray(tmp_14) ? tmp_14 : THROW_CCE();
          var tmp_15 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          var size_3 = this.entryCount_1;
          var tmp_16 = Array(size_3);
          tmp_15.valueStorage_1 = isArray(tmp_16) ? tmp_16 : THROW_CCE();
          var tableSize_0 = tableSizeFor(Companion_instance, this.entryCount_1);
          var tmp_17 = this;
          var tmp_18 = 0;
          var tmp_19 = new Int32Array(tableSize_0);
          while (tmp_18 < tableSize_0) {
            tmp_19[tmp_18] = -1;
            tmp_18 = tmp_18 + 1 | 0;
          }
          tmp_17.hashBuckets_1 = tmp_19;
          var tmp_20 = this;
          var tmp_21 = 0;
          var tmp_22 = this.entryCount_1;
          var tmp_23 = new Int32Array(tmp_22);
          while (tmp_21 < tmp_22) {
            tmp_23[tmp_21] = -1;
            tmp_21 = tmp_21 + 1 | 0;
          }
          tmp_20.hashNext_1 = tmp_23;
          var i_0 = 0;
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_1 = deduped.get_entries_p20ztl_k$().iterator_jk1svi_k$();
          while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
            var _destruct__k2r9zo_1 = _iterator__ex2g4s_1.next_20eer_k$();
            // Inline function 'kotlin.collections.component1' call
            var key_1 = _destruct__k2r9zo_1.get_key_18j28a_k$();
            // Inline function 'kotlin.collections.component2' call
            var value_2 = _destruct__k2r9zo_1.get_value_j01efc_k$();
            this.keyStorage_1[i_0] = key_1;
            var tmp_24 = i_0;
            // Inline function 'kotlin.collections.List' call
            // Inline function 'kotlin.collections.MutableList' call
            var size_4 = value_2.get_size_woubt6_k$();
            var list_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(size_4);
            // Inline function 'kotlin.repeat' call
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < size_4)
              do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp$ret$30 = value_2.get_c1px32_k$(index_0);
                list_0.add_utx5q5_k$(tmp$ret$30);
              }
               while (inductionVariable_0 < size_4);
            this.valueStorage_1[tmp_24] = list_0;
            var hash_0 = computeHash(this, key_1);
            var bucket_0 = hash_0 & (tableSize_0 - 1 | 0);
            this.hashNext_1[i_0] = this.hashBuckets_1[bucket_0];
            this.hashBuckets_1[bucket_0] = i_0;
            i_0 = i_0 + 1 | 0;
          }
        }
      }
      get_caseInsensitiveName_ehooe5_k$() {
        return this.caseInsensitiveName_1;
      }
      get_6bo4tg_k$(name) {
        var tmp0_safe_receiver = listForKey(this, name);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
      }
      getAll_ffxf4h_k$(name) {
        return listForKey(this, name);
      }
      names_1q9mbs_k$() {
        if (this.entryCount_1 === 0)
          return emptySet();
        // Inline function 'kotlin.collections.linkedSetOf' call
        var result = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
        var inductionVariable = 0;
        var last = this.entryCount_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            result.add_utx5q5_k$(this.keyStorage_1[i]);
          }
           while (inductionVariable < last);
        return result;
      }
      isEmpty_y1axqb_k$() {
        return this.entryCount_1 === 0;
      }
      entries_qbkxv4_k$() {
        if (this.entryCount_1 === 0)
          return emptySet();
        // Inline function 'kotlin.collections.linkedSetOf' call
        var result = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
        var inductionVariable = 0;
        var last = this.entryCount_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            result.add_utx5q5_k$(new (StringValuesEntry())(this.keyStorage_1[i], this.valueStorage_1[i]));
          }
           while (inductionVariable < last);
        return result;
      }
      forEach_jocloe_k$(body) {
        var inductionVariable = 0;
        var last = this.entryCount_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            body(this.keyStorage_1[i], this.valueStorage_1[i]);
          }
           while (inductionVariable < last);
      }
      toString() {
        return 'StringValues(case=' + !this.caseInsensitiveName_1 + ') ' + toString_0(this.entries_qbkxv4_k$());
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(!(other == null) ? isInterface(other, StringValues()) : false))
          return false;
        if (!(this.caseInsensitiveName_1 === other.get_caseInsensitiveName_ehooe5_k$()))
          return false;
        return entriesEquals(this.entries_qbkxv4_k$(), other.entries_qbkxv4_k$());
      }
      hashCode() {
        return entriesHashCode(this.entries_qbkxv4_k$(), imul(31, getBooleanHashCode(this.caseInsensitiveName_1)));
      }
    }
    initMetadataForClass($, 'StringValuesImpl', StringValuesImpl, VOID, [StringValues()]);
    StringValuesImplClass = $;
  }
  return StringValuesImplClass;
}
var StringValuesSingleImpl$entries$1Class;
function StringValuesSingleImpl$entries$1() {
  if (StringValuesSingleImpl$entries$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.key_1 = this$0.name_1;
        this.value_1 = this$0.values_1;
      }
      get_key_18j28a_k$() {
        return this.key_1;
      }
      get_value_j01efc_k$() {
        return this.value_1;
      }
      toString() {
        return this.key_1 + '=' + toString_0(this.value_1);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (!(other == null) ? isInterface(other, Entry()) : false) {
          tmp_0 = equals_0(other.get_key_18j28a_k$(), this.key_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals_0(other.get_value_j01efc_k$(), this.value_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.key_1) ^ hashCode(this.value_1);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Entry()]);
    StringValuesSingleImpl$entries$1Class = $;
  }
  return StringValuesSingleImpl$entries$1Class;
}
var StringValuesSingleImplClass;
function StringValuesSingleImpl() {
  if (StringValuesSingleImplClass === VOID) {
    class $ {
      constructor(caseInsensitiveName, name, values) {
        this.caseInsensitiveName_1 = caseInsensitiveName;
        this.name_1 = name;
        this.values_1 = values;
      }
      get_caseInsensitiveName_ehooe5_k$() {
        return this.caseInsensitiveName_1;
      }
      getAll_ffxf4h_k$(name) {
        return equals(this.name_1, name, this.get_caseInsensitiveName_ehooe5_k$()) ? this.values_1 : null;
      }
      entries_qbkxv4_k$() {
        return setOf(new (StringValuesSingleImpl$entries$1())(this));
      }
      isEmpty_y1axqb_k$() {
        return false;
      }
      names_1q9mbs_k$() {
        return setOf(this.name_1);
      }
      toString() {
        return 'StringValues(case=' + !this.get_caseInsensitiveName_ehooe5_k$() + ') ' + toString_0(this.entries_qbkxv4_k$());
      }
      hashCode() {
        return entriesHashCode(this.entries_qbkxv4_k$(), imul(31, getBooleanHashCode(this.get_caseInsensitiveName_ehooe5_k$())));
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(!(other == null) ? isInterface(other, StringValues()) : false))
          return false;
        if (!(this.get_caseInsensitiveName_ehooe5_k$() === other.get_caseInsensitiveName_ehooe5_k$()))
          return false;
        return entriesEquals(this.entries_qbkxv4_k$(), other.entries_qbkxv4_k$());
      }
      forEach_jocloe_k$(body) {
        return body(this.name_1, this.values_1);
      }
      get_6bo4tg_k$(name) {
        return equals(name, this.name_1, this.get_caseInsensitiveName_ehooe5_k$()) ? firstOrNull(this.values_1) : null;
      }
    }
    initMetadataForClass($, 'StringValuesSingleImpl', VOID, VOID, [StringValues()]);
    StringValuesSingleImplClass = $;
  }
  return StringValuesSingleImplClass;
}
function entriesEquals(a, b) {
  return equals_0(a, b);
}
function entriesHashCode(entries, seed) {
  return imul(seed, 31) + hashCode(entries) | 0;
}
function flattenEntries(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = _this__u8e3s4.entries_qbkxv4_k$();
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.collections.map' call
    var this_0 = element.get_value_j01efc_k$();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp$ret$5 = to(element.get_key_18j28a_k$(), item);
      destination_0.add_utx5q5_k$(tmp$ret$5);
    }
    var list = destination_0;
    addAll(destination, list);
  }
  return destination;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  forEach as forEachghjt92rkrpzo,
  get as get3oezx9z3zutmm,
  StringValuesBuilderImpl as StringValuesBuilderImpl3ey9etj3bwnqf,
  StringValuesImpl as StringValuesImpl2l95y9du7b61t,
  StringValuesSingleImpl as StringValuesSingleImpl1uh7q2c2zm7va,
  StringValues as StringValuesjqid5a6cuday,
  appendAll as appendAlltwnjnu28pmtx,
  flattenEntries as flattenEntries2zw7fl55k6a0l,
};
//endregion

//# sourceMappingURL=StringValues.mjs.map
